import Modules from '@/utils/modules'
import SettingTypes from '@/utils/setting-types'

const assetIcon = require('@/assets/icon-component-label_PointsAsset.svg')
const goodsIcon = require('@/assets/icon-component-label_Goods.png')
const couponIcon = require('@/assets/icon-component-label_Coupon.svg')
const moduleOf = (name, title, icon, data, settings) => ({
  name, decor_type: 'admin', label: { title, icon, limit: 1 }, data, settings
})
const input = label => ({ type: SettingTypes.input, label })
const toggle = label => ({ type: SettingTypes.boolean, label })
const color = label => ({ type: SettingTypes.color_picker, label, default: '#202020' })

// 仅供独立积分编辑器使用，不注入普通首页组件列表。
export default [
  moduleOf('points-summary', '积分资产', assetIcon, { title: '我的消费积分', show_details: true, theme_color: '#202020' }, {
    title: input('资产名称'), show_details: toggle('显示积分明细入口'), theme_color: color('背景颜色')
  }),
  moduleOf('points-goods', '积分兑换商品', goodsIcon, { title: '积分兑换商品', layout: 'single', show_categories: true, show_original_price: true }, {
    title: input('模块标题'),
    layout: { type: SettingTypes.radio_button, label: '商品布局', options: [{ label: '单列', value: 'single' }, { label: '双列', value: 'row-two' }] },
    show_categories: toggle('显示积分分类'), show_original_price: toggle('显示原价')
  }),
  moduleOf('points-coupons', '积分兑换券/码', couponIcon, { title: '积分兑换券/码', theme_color: '#202020' }, {
    title: input('模块标题'), theme_color: color('兑换按钮颜色')
  }),
  ...Modules
]
